<template>
  <transition>
    <div class="mod-dial" @click="CATEGORIES_SET_MANAGER_VISIBLE(false)">
      <div class="mod-cont" @click.stop>
        <span class="close-main" @click.stop="CATEGORIES_SET_MANAGER_VISIBLE(false)">
          <i class="bi bi-x-lg"></i>
        </span>
        <div class="mod-body">
          <div class="mod-access cat-manager">
            <h3 class="tab-title">{{ getCurrentCategory ? getCurrentCategory.name : $t('CATEGORY_MANAGER_TITLE') }}</h3>

    

    <!-- Category Name Edit -->
    <div class="category-pages">
      <span class="text-header">{{ $t('CATEGORY_MANAGER_NAME') }}</span>
      <form @submit.prevent="updateCategory" class="inp-btn">
        <input
          type="text"
          class="inp-st"
          placeholder="Category name"
          v-model="categoryName"
          maxlength="25"
        />
        <button class="btn-st-red" type="submit">
          {{ $t('CATEGORY_MANAGER_UPDATE') }}
        </button>
      </form>
    </div>

    <!-- Pages in Category -->
    <div class="category-pages" v-if="categoryPages.length">
      <div class="sel-pages">
        <div class="sel-list">
          <div
            class="sel-pg"
            :key="index"
            v-for="(page, index) in categoryPages"
          >
            <img :src="page.owner_avatar" alt />
            <div>
              <p>{{ truncateName(page.owner_name) }}</p>
              <span v-if="page.social == 'FB'">Facebook</span>
              <span v-if="page.social == 'IG'">Instagram</span>
              <span v-if="page.social == 'VK'">VK</span>
            </div>
            <span class="close" @click="removePageFromCategory(page)"><i class="bi bi-x-lg"></i></span>
          </div>
        </div>
      </div>
    </div>
    
    <div class="category-pages">
      <span class="text-header">{{ $t("ACCESS_MANAGER_GRANT_ACCESS") }}</span>
      <form @submit.prevent="shareAccess" class="inp-btn">
        <input
          type="text"
          class="inp-st"
          placeholder="Email"
          v-model="shareEmail"
        />
        <button class="btn-st-red" type="submit">
          {{ $t("ACCESS_MANAGER_GIVE_ACCESS") }}
        </button>
      </form>
    </div>

    <!-- Access List -->
    <div class="tab-wrapper">
      <table class="acc-tab">
        <thead>
          <tr>
            <th>{{ $t("ACCESS_MANAGER_EMAIL") }}</th>
            <th>{{ $t("ACCESS_MANAGER_ACTION") }}</th>
          </tr>
        </thead>
        <tbody :key="index" v-for="(access, index) in getCategoriesAccessList">
          <tr>
            <td>{{ access.granted_to_email }}</td>
            <td>
              <span class="remove" @click="removeAccess(access.granted_to_email)">{{
                $t("ACCESS_MANAGER_REMOVE_ACCESS")
              }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Container for inline alerts -->
      <div ref="alertContainer"></div>
    </div>

            <!-- Delete Category -->
                  <button class="btn-st-red" type="button" @click="deleteCategory">
        {{ $t('CATEGORY_MANAGER_DELETE') }}
      </button>
          </div> <!-- close mod-access -->
        </div> <!-- close mod-body -->
      </div> <!-- close mod-cont -->
    </div> <!-- close mod-dial -->
  </transition>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  CATEGORIES_SET_ACCESS_LIST,
  CATEGORIES_SHARE_ACCESS,
  CATEGORIES_REMOVE_ACCESS,
  CATEGORIES_DELETE,
  CATEGORIES_UPDATE,
  CATEGORIES_SET_MANAGER_VISIBLE,
  CATEGORIES_SET_LIST,
  CATEGORIES_SET_CURRENT,
  CATEGORIES_REMOVE_PAGE,
  CATEGORIES_GET_BY_ID,
} from "../../store/actions/categories";

export default {
  name: "CategoryManager",
  computed: {
    ...mapGetters([
      "getCurrentCategory",
      "getCategoriesAccessList",
      "getPages"
    ]),
    categoryPages() {
      if (!this.getCurrentCategory) return [];
      if (this.getCurrentCategory.pages) {
        return this.getCurrentCategory.pages.filter(page => page.status !== 'deleted');
      } else if (this.getCurrentCategory.page_ids) {
        return this.getPages.filter(page => 
          this.getCurrentCategory.page_ids.includes(page.page_id) && page.status !== 'deleted'
        );
      }
      
      return [];
    },
    
    currentCategoryPageIds() {
      if (!this.getCurrentCategory) return [];
      if (this.getCurrentCategory.pages && this.getCurrentCategory.pages.length > 0) {
        return this.getCurrentCategory.pages.map(page => page.page_id);
      } else if (this.getCurrentCategory.page_ids) {
        return this.getCurrentCategory.page_ids;
      }
      
      return [];
    }
  },
  data() {
    return {
      shareEmail: "",
      categoryName: "",
    };
  },
  mounted() {
    if (this.getCurrentCategory) {
      this.categoryName = this.getCurrentCategory.name;
      this.fetchAccessList();
    }
  },
  watch: {
    getCurrentCategory(newCategory) {
      if (newCategory) {
        this.categoryName = newCategory.name;
        this.fetchAccessList();
      }
    }
  },
  methods: {
    ...mapActions([
      CATEGORIES_SET_ACCESS_LIST,
      CATEGORIES_SHARE_ACCESS,
      CATEGORIES_REMOVE_ACCESS,
      CATEGORIES_DELETE,
      CATEGORIES_UPDATE,
      CATEGORIES_SET_LIST,
      CATEGORIES_REMOVE_PAGE,
      CATEGORIES_GET_BY_ID,
    ]),
    ...mapMutations([
      CATEGORIES_SET_MANAGER_VISIBLE,
      CATEGORIES_SET_CURRENT,
    ]),

    async fetchAccessList() {
      if (this.getCurrentCategory) {
        await this[CATEGORIES_SET_ACCESS_LIST](this.getCurrentCategory.id);
      }
    },

    async shareAccess() {
      if (!this.shareEmail || !this.getCurrentCategory) return;
      
      try {
        await this[CATEGORIES_SHARE_ACCESS]({
          categoryId: this.getCurrentCategory.id,
          granted_to_email: this.shareEmail
        });
        
        // Explicitly refresh the access list to ensure UI updates
        await this[CATEGORIES_SET_ACCESS_LIST](this.getCurrentCategory.id);
        
        this.shareEmail = "";
        this.showInlineAlert(this.$t('CATEGORY_MANAGER_ACCESS_GRANTED'));
      } catch (error) {
        if (error?.response?.data?.error_code) {
          this.showInlineAlert(this.$t(error.response.data.error_code));
        } else {
          this.showInlineAlert(this.$t('CATEGORY_MANAGER_ACCESS_ERROR'));
        }
      }
    },

    async removeAccess(email) {
      if (!this.getCurrentCategory) return;
      
      try {
        await this[CATEGORIES_REMOVE_ACCESS]({
          categoryId: this.getCurrentCategory.id,
          email: email
        });
        
        // Explicitly refresh the access list to ensure UI updates
        await this[CATEGORIES_SET_ACCESS_LIST](this.getCurrentCategory.id);
        
        this.showInlineAlert(this.$t('CATEGORY_MANAGER_ACCESS_REMOVED'));
      } catch (error) {
        if (error?.response?.data?.error_code) {
          this.showInlineAlert(this.$t(error.response.data.error_code));
        } else {
          this.showInlineAlert(this.$t('CATEGORY_MANAGER_REMOVE_ERROR'));
        }
      }
    },

    async updateCategory() {
      if (!this.categoryName || !this.getCurrentCategory) return;
      
      try {
        const response = await this[CATEGORIES_UPDATE]({
          id: this.getCurrentCategory.id,
          name: this.categoryName,
          page_ids: this.currentCategoryPageIds
        });
        
        // Update the current category with the response data to refresh modal content
        if (response && response.category) {
          this[CATEGORIES_SET_CURRENT](response.category);
        }
        
        // Show global success alert
        this.$store.dispatch('alerts/addAlert', {
          message: this.$t('CATEGORY_MANAGER_UPDATED'),
          color: 'success',
          duration: 5000
        });
      } catch (error) {
        if (error?.response?.data?.error_code) {
          this.showInlineAlert(this.$t(error.response.data.error_code));
        } else {
          this.showInlineAlert(this.$t('CATEGORY_MANAGER_UPDATE_ERROR'));
        }
      }
    },

    async removePageFromCategory(page) {
      if (!this.getCurrentCategory) return;
      
      try {
        await this[CATEGORIES_REMOVE_PAGE]({
          page_id: page.page_id,
          category_id: this.getCurrentCategory.id
        });
        
        // Refresh the current category data to get updated page list
        const updatedCategory = await this[CATEGORIES_GET_BY_ID](this.getCurrentCategory.id);
        this[CATEGORIES_SET_CURRENT](updatedCategory);
        
        this.showInlineAlert(this.$t('CATEGORY_MANAGER_PAGE_REMOVED'));
      } catch (error) {
        if (error?.response?.data?.error_code) {
          this.showInlineAlert(this.$t(error.response.data.error_code));
        } else {
          this.showInlineAlert(this.$t('CATEGORY_MANAGER_PAGE_REMOVE_ERROR'));
        }
      }
    },

    async deleteCategory() {
      if (!this.getCurrentCategory) return;
      
      if (confirm(`Are you sure you want to delete category "${this.getCurrentCategory.name}"?`)) {
        try {
          await this[CATEGORIES_DELETE](this.getCurrentCategory.id);
          this[CATEGORIES_SET_MANAGER_VISIBLE](false);
          this[CATEGORIES_SET_CURRENT](null);
          this.showInlineAlert(this.$t('CATEGORY_MANAGER_DELETED'));
        } catch (error) {
          if (error?.response?.data?.error_code) {
            this.showInlineAlert(this.$t(error.response.data.error_code));
          } else {
            this.showInlineAlert(this.$t('CATEGORY_MANAGER_DELETE_ERROR'));
          }
        }
      }
    },

    truncateName(name) {
      if (!name) return '';
      const maxLength = 25;
      return name.length > maxLength ? name.substring(0, maxLength) + '...' : name;
    },

    showInlineAlert(message) {
      this.$alert.show({
        message: message,
        type: 'inline',
        color: '',
        component: this,
        target: this.$refs.alertContainer,
      });
    },
  },
};
</script>

<style>
</style> 